// extracted by mini-css-extract-plugin
export default {"jobTrend":"JobTrend_jobTrend__TeE18","clickable":"JobTrend_clickable__1CFNN","active":"JobTrend_active__Ai-V9"};